import { render, staticRenderFns } from "./McFormAlarmContacts.vue?vue&type=template&id=c44ba90a"
import script from "./McFormAlarmContacts.vue?vue&type=script&lang=js"
export * from "./McFormAlarmContacts.vue?vue&type=script&lang=js"
import style0 from "./McFormAlarmContacts.vue?vue&type=style&index=0&id=c44ba90a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports